import AsyncStorage from '@react-native-async-storage/async-storage'
import { useRef, useEffect } from 'react'

interface Args<T> {
  initialData: T
  setDataFromStorage: (data: T) => void
  key: string
}

export const useStorage = <T>({ initialData, setDataFromStorage, key }: Args<T>) => {
  const isFirstRender = useRef(true)

  const removeStorage = async () => await AsyncStorage.removeItem(key)

  useEffect(() => {
    const saveData = async () => {
      await AsyncStorage.setItem(key, JSON.stringify(initialData))
    }
    if (!isFirstRender.current) {
      saveData()
    }
  }, [initialData])

  useEffect(() => {
    const checkData = async () => {
      const data = await AsyncStorage.getItem(key)
      if (data) {
        setDataFromStorage(JSON.parse(data))
      }
    }

    checkData()
  }, [])

  return { isFirstRender, removeStorage }
}
